module.exports = __webpack_public_path__ + "static/media/capture_border_red.803943a6.png";